import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DateProviderState } from "./date-provider.state";
import { StoreConstants } from "src/app/constants/StoreConstants";
import { DateProvider } from "src/app/_models/DateProvider";

export const selectDateProviderState = createFeatureSelector<DateProviderState>(StoreConstants.STATE_DP);

export const selectGetDateProvider = createSelector(
    selectDateProviderState,
    (state: DateProviderState): DateProvider => state.dateProvider
);